import "./src/styles/globals.scss";
import "react-dropdown/style.css";

// import function to register Swiper custom elements
import { register } from "swiper/element/bundle";
// register Swiper custom elements
register();
